// @ts-nocheck

import React from 'react';
import { navigate } from '../../../lib/routerAdapter';
import notification from 'antd/lib/notification';
import { connect } from 'react-redux';

import Input from 'antd/lib/input/Input';
import styled from 'styled-components';
import Button from 'antd/lib/button';
import moment from 'moment';
import orderBy from 'lodash/orderBy';
import { DatePicker } from '../../../components/ant/DatePicker';

import { Header, Section } from '../../../components/layout';
import {
  cleanVehicle,
  fetchVehicle,
  updateVehicle } from
'../../../ducks/vehicle';


import Grid, { GridItem } from '../../../components/layout/Grid';
import Form from '../../../components/Form';
import { formatDateTimeToISOString as changeDate } from './../../../lib/helpers';
import { notificationLoading } from './../../../components/Notifications';
import CancelButton from '../../../components/CancelButton';
import Uploader from '../components/Uploader';
import { replaceFilesByTag } from '../files';
import { fileTagEnum } from '../../../lib/enum';
import ContractorSelect from '../../../components/selects/ContractorSelect';

const StyledSection = styled(Section)`
  padding: 16px;
`;
const Footer = styled(Section)`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;









class Kasko extends React.Component {
  async componentDidMount() {
    const { vehicleId } = this.props;
    await this.props.cleanVehicle();
    try {
      await this.props.fetchVehicle(vehicleId);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  }

  onSubmit = async (values) => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      await this.props.updateVehicle(values);
      notification.success({
        message: 'Успешно сохранено',
        description: 'Изменения успешно сохранены'
      });
      navigate(`/vehicles/${values.id}/insurance`);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  handleCancel = () => {
    navigate(`/vehicles/${this.props.vehicleId}/insurance`);
  };

  formatDate = (value) => {
    return value ? moment.utc(value) : value;
  };

  render() {
    const { vehicle = {} } = this.props;
    return (
      <>
        <Header left={vehicle && <h1>КАСКО {vehicle.licensePlate}</h1>} />
        <Form initialValues={vehicle || {}} onSubmit={this.onSubmit}>
          {(FormField, formikProps) => {
            const { handleSubmit, setFieldValue, dirty } = formikProps;
            return (
              <form onSubmit={handleSubmit}>
                <StyledSection>
                  <Grid gutter="16px">
                    <GridItem>
                      <FormField
                        label="Номер полиса КАСКО"
                        required
                        name="kasko.kaskoNumber">

                        {(field) => <Input {...field} />}
                      </FormField>
                    </GridItem>
                    <GridItem>
                      <FormField label="Скан документа" name="files">
                        {({ value = [], name }) => {
                          const preparedValue = orderBy(
                            value.filter((v) => v.tag === fileTagEnum.osago),
                            'createdTime',
                            ['desc']
                          ).slice(0, 1);
                          return (
                            <Uploader
                              tag={fileTagEnum.osago}
                              value={preparedValue}
                              onChange={(files) => {
                                setFieldValue(
                                  name,
                                  replaceFilesByTag(
                                    value,
                                    fileTagEnum.osago,
                                    files
                                  )
                                );
                              }} />);


                        }}
                      </FormField>
                    </GridItem>
                    <GridItem>
                      <FormField
                        label="Наименование страховщика"
                        required
                        name="kasko.contractorId">

                        {({ value, name }) =>
                        <ContractorSelect
                          value={value}
                          name={name}
                          onChange={(id) => setFieldValue(name, id)}
                          placeholder="Введите страховщика" />

                        }
                      </FormField>
                    </GridItem>
                    <GridItem>
                      <Grid gutter="16px">
                        <GridItem>
                          <FormField
                            label="Дата начала действия"
                            required
                            name="kasko.startDate">

                            {({ value, name }) =>
                            <DatePicker
                              format="DD.MM.YYYY"
                              value={this.formatDate(value)}
                              onChange={(
                              value,
                              dateString) =>
                              {
                                setFieldValue(
                                  name,
                                  changeDate(value, dateString)
                                );
                              }} />

                            }
                          </FormField>
                        </GridItem>
                        <GridItem>
                          <FormField
                            label="Дата окончания действия"
                            required
                            name="kasko.endDate">

                            {({ value, name }) =>
                            <DatePicker
                              format="DD.MM.YYYY"
                              value={this.formatDate(value)}
                              name={name}
                              onChange={(
                              value,
                              dateString) =>
                              {
                                setFieldValue(
                                  name,
                                  changeDate(value, dateString)
                                );
                              }} />

                            }
                          </FormField>
                        </GridItem>
                      </Grid>
                    </GridItem>
                  </Grid>
                </StyledSection>
                <Footer>
                  <Button type="primary" htmlType="submit">
                    Сохранить
                  </Button>
                  <CancelButton dirty={dirty} onClick={this.handleCancel}>
                    Отменить
                  </CancelButton>
                </Footer>
              </form>);

          }}
        </Form>
      </>);

  }
}

export default connect(
  (state, props) => ({
    vehicle: state.vehicle,
    vehicleId: parseInt(props.vehicleId, 10)
  }),
  {
    fetchVehicle,
    cleanVehicle,
    updateVehicle
  }
)(Kasko);
